import {
  BasicButton,
  ButtonGroup,
  Grid,
  GridItem,
  LegacyModal,
  Link,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTrigger,
  PrimaryButton,
  TextInputField,
} from "@certn/cascadia-react";
import { Field, Form, Formik } from "formik";
import { Trans, useTranslation } from "react-i18next";
import { object, string } from "yup";

type SingleInputModalProps = {
  type: "Facebook" | "Instagram" | "X" | "LinkedIn" | "TikTok" | "high school";
  label: string;
  value: string;
  onChange: (value: string) => void;
  isRequired?: boolean;
  testID?: string;
};

export function SingleInputModal({
  type,
  label,
  value,
  onChange,
  isRequired,
  testID,
}: SingleInputModalProps) {
  const { t } = useTranslation();

  return (
    <ModalTrigger
      trigger={() => (
        <Link
          linkStyle="monochrome"
          textStyle="global/body-secondary"
          testID={value ? `${testID}-edit-button` : `${testID}-add-button`}
        >
          {value ? t("Edit") : t("Add")}
        </Link>
      )}
    >
      {(close) => (
        <Formik
          initialValues={{
            value,
          }}
          onSubmit={({ value }) => {
            onChange(value);
            close();
          }}
          validationSchema={
            isRequired &&
            object().shape({
              value: string().required().label(label),
            })
          }
        >
          {({ handleSubmit }) => (
            <LegacyModal width="456px">
              <ModalHeader
                close={close}
                title={
                  value
                    ? t(`Edit {{type}} details`, { type })
                    : t(`Add {{type}} details`, { type })
                }
                testID={`${testID}-modal`}
              />

              <ModalContent>
                <Form>
                  <Grid>
                    <GridItem>
                      <Field
                        label={label}
                        name="value"
                        isRequired
                        as={TextInputField}
                        testID={`${testID}-modal-input`}
                      />
                    </GridItem>
                  </Grid>
                </Form>
              </ModalContent>

              <ModalFooter>
                <ButtonGroup>
                  <BasicButton
                    size="medium"
                    onPress={close}
                    testID={`${testID}-modal-cancel-button`}
                  >
                    <Trans>Cancel</Trans>
                  </BasicButton>
                  <PrimaryButton
                    type="submit"
                    size="medium"
                    onPress={() => handleSubmit()}
                    testID={`${testID}-modal-submit-button`}
                  >
                    {value ? t("Save") : t("Add")}
                  </PrimaryButton>
                </ButtonGroup>
              </ModalFooter>
            </LegacyModal>
          )}
        </Formik>
      )}
    </ModalTrigger>
  );
}
